import React, { useEffect } from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch } from "react-redux";
import { bugModalClosed } from "../store/components";
import BugReportContent from "./BugReportContent";

// Adapted from Login.jsx
// This contains all the modal information

const BugReport = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(bugModalClosed());
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <section
        className="text-center align-items-center"
        style={{
          display: "flex",
          height: "100%",
          position: "relative",
          backgroundColor: "#eef3f6",
        }}
      >
        <BugReportContent></BugReportContent>
        <div style={{ position: "absolute", top: 10, right: 20 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer" }}
            onClick={() => {
              dispatch(bugModalClosed());
            }}
          ></CancelIcon>
        </div>
      </section>
    </div>
  );
};

export default BugReport;
